import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, getTranslation } from '@resy/ui-kitchen';
import CheckboxSimple from '../../../../../ui-kitchen/src/components/Checkbox/CheckboxSimple';
import Close from '../../../../../ui-kitchen/src/svg/icons/ic_close_20x20.svg';
import ResyLogo from '../../../images/resy-logo-red.svg';
import TockLogo from '../../../../../ui-kitchen/src/svg/logos/tock-logo.svg';
import Logger from '../../../../../ui-kitchen/src/utils/logger';
import { HIDE_TOCK_INTERSTITIAL } from '../../../../../ui-kitchen/src/reducers/tockInterstitialSlice';

import './TockInterstitial.scss';

const getInitialHidePreference = () => {
  if (typeof window === 'undefined') return false;

  try {
    return window.localStorage.getItem(HIDE_TOCK_INTERSTITIAL) === 'true';
  } catch {
    return false;
  }
};

const TockInterstitial = ({ onConfirm, onClose }) => {
  const [hideInterstitial, setHideInterstitial] = useState(getInitialHidePreference);

  const handlePreferenceChange = (event) => {
    const { checked } = event.target;
    setHideInterstitial(checked);

    try {
      window.localStorage.setItem(HIDE_TOCK_INTERSTITIAL, checked ? 'true' : 'false');
    } catch {
      Logger.log('TockInterstitial: failed to persist hide preference');
    }
  };

  return (
    <div className="TockInterstitial" data-test-id="tock-interstitial">
      <Button
        onClick={onClose}
        variant="no-style"
        className="TockInterstitial__Close"
        data-test-id="tock-interstitial-button-close"
        aria-label={getTranslation({ translationKey: 'close', fallback: 'Close' })}
      >
        <Close />
      </Button>
      <div className="TockInterstitial__Header">
        <p className="TockInterstitial__Subheader">
          {getTranslation({
            translationKey: 'tock_interstitial_subheader',
            fallback: 'Tock is now part of the Resy Network',
          })}
        </p>
        <div className="TockInterstitial__Logos" aria-hidden="true">
          <ResyLogo className="TockInterstitial__Logo TockInterstitial__Logo--resy" />
          <TockLogo className="TockInterstitial__Logo TockInterstitial__Logo--tock" />
        </div>
      </div>
      <div className="TockInterstitial__Body">
        <h2 className="TockInterstitial__Title">
          {getTranslation({
            translationKey: 'tock_interstitial_header',
            fallback: 'Finish booking on Tock',
          })}
        </h2>
        <p className="TockInterstitial__Description">
          {getTranslation({
            translationKey: 'tock_interstitial_description',
            fallback: "This reservation is managed by Tock. You'll be redirected to Tock to complete your booking.",
          })}
        </p>
      </div>
      <div className="TockInterstitial__Footer">
        <div className="TockInterstitial__Preference">
          <CheckboxSimple
            name="tock-interstitial-hide"
            checked={hideInterstitial}
            onChange={handlePreferenceChange}
          />
          <label htmlFor="tock-interstitial-hide" className="TockInterstitial__PreferenceLabel">
            {getTranslation({
              translationKey: 'tock_interstitial_preference_hide',
              fallback: "Don't show this again",
            })}
          </label>
        </div>
        <Button
          className="TockInterstitial__CTA"
          variant="primary"
          onClick={onConfirm}
          data-test-id="tock-interstitial-button-confirm"
        >
          {getTranslation({
            translationKey: 'tock_interstitial_confirm_cta',
            fallback: 'Continue to Book on Tock',
          })}
        </Button>
      </div>
    </div>
  );
};

TockInterstitial.displayName = 'TockInterstitial';

TockInterstitial.propTypes = {
  onConfirm: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default TockInterstitial;
